import { useGtm } from "vue-gtm";

export const trackGtmEvent = (category, action) => {
  const gtm = useGtm();
  gtm.trackEvent({
    event: "click",
    category: category,
    action: action,
  });
};
